module.exports = __webpack_public_path__ + "static/media/board-Janet_Morrison.bbe4eef2.jpg";